import { css } from '@emotion/react';



export const orcid = () => css `
    text-decoration: none;
  >img {
    margin-right: 4px;
    vertical-align: middle;
  };
`